import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import {
    HTMLAttributes,
    ReactNode, useContext, useEffect, useId,
} from 'react';

import TabContext from './TabContext';

interface Props extends HTMLAttributes<HTMLDivElement>{
    selected?: boolean;
}

function TabItem({
    children, onClick, selected, ...rest
}:Props) {
    const { variant, setCurrentId } = useContext(TabContext);
    const id = useId();
    useEffect(() => {
        if (selected) {
            setCurrentId(id);
        }
    }, [selected, id, setCurrentId]);
    if (variant === 'solid') {
        return (
            <SolidTabItem onClick={onClick}
                id={id}
                aria-label='tab'
                data-selected={!!selected}
                {...rest} >
                <Text size='body-short'
                    color={selected ? colors.textSecondary : colors.textThird}
                    fontWeight='bold'>
                    {children}
                </Text>
            </SolidTabItem>
        );
    }
    return (
        <LineTabItem id={id}
            aria-label='tab'
            data-selected={!!selected}
            onClick={onClick}
            {...rest} >
            <Text size='body-short'
                fontWeight={selected ? 'bold' : 'regular'} >
                {children}
            </Text>
        </LineTabItem>
    );
}

const LineTabItem = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 16px 0;
`;

const SolidTabItem = styled.div`
    align-items: center;
    border-radius: 6px;
    display: flex;
    height: 36px;
    justify-content: center;
    padding: 8px;
`;

export default TabItem;
